module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('el-image', {
    staticStyle: {
      "width": "260px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.cardInfo.icon,
      "fit": "contain"
    },
    on: {
      "click": _vm.directToPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-492faf87","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomcard.vue
// module id = 1065
// module chunks = 2